/**
 * Roadmap Frontend Entry Point
 * 
 * Renders the public-facing roadmap component
 */
import { render } from '@wordpress/element';
import RoadmapApp from './RoadmapApp';
import './styles/index.css';

// Initialize Roadmap App
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('cha-roadmap-root');
    
    if (container) {
        const frontendConfig = window.chaRoadmapFrontend || {};
        
        const config = {
            restUrl: frontendConfig.restUrl || '/wp-json/changeloger/v1/roadmap',
            productsUrl: frontendConfig.productsUrl || '/wp-json/changeloger/v1/products',
            nonce: frontendConfig.nonce || '',
            product: container.dataset.product || '',
            columns: frontendConfig.columns || {},
            // User status
            isLoggedIn: frontendConfig.isLoggedIn === '1' || false,
            currentUser: frontendConfig.currentUser || null,
            // Roadmap settings
            enableRoadmap: frontendConfig.enableRoadmap === '1' || false,
            showVoteCount: frontendConfig.showVoteCount === '1' || false,
            columnsPerRow: parseInt(frontendConfig.columnsPerRow, 10) || 4,
            // Voting settings
            enableDownvoting: frontendConfig.enableDownvoting === '1' || false,
            allowGuestVoting: frontendConfig.allowGuestVoting === '1' || false,
            // Auth settings
            enableGoogleLogin: frontendConfig.enableGoogleLogin === '1' || false,
            enableEmailSignup: frontendConfig.enableEmailSignup === '1' || false,
            loginUrl: frontendConfig.loginUrl || '',
            registerUrl: frontendConfig.registerUrl || '',
            ajaxUrl: frontendConfig.ajaxUrl || '',
        };
        
        render(<RoadmapApp config={config} />, container);
    }
});
